import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { ROLES } from '../constants/roles';

const ProtectedRoute = ({ children }) => {
    const { user, token, isLoading, role } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return <div>Loading...</div>; // Or a spinner component
    }

    if (!token || !user) {
        return <Navigate to="/login" replace />;
    }

    // HomePage.js handles role-based routing
    // ProtectedRoute only handles authentication, not role-based redirects
    return children;
};

export default ProtectedRoute;
